import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DomainFragment, GetDomains as GetDomainsQuery} from 'nutshell-graphql-types';

import GET_DOMAINS from '../queries/get-domains.graphql';

export function useGetDomains(): {
    domains: DomainFragment[];
    isLoading: boolean;
    error: string | null | undefined;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
} {
    const {data, error, loading, startPolling, stopPolling} = useQuery<
        GetDomainsQuery,
        Record<any, any>
    >(GET_DOMAINS, {
        fetchPolicy: 'cache-and-network',
    });

    return {
        domains: data && data.domains ? data.domains : [],
        isLoading: loading,
        startPolling,
        stopPolling,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
